<div #racine class="verrou-ecran" tabindex="-1" role="dialog" aria-modal="true" [attr.aria-label]="'VERROU.TITLE' | translate">
  <div class="verrou-carte">
    <div class="verrou-avatar" aria-hidden="true">{{ initiale() }}</div>
    <span class="verrou-nom">{{ nom() }}</span>
    <h2 class="verrou-titre"><i class="pi pi-lock" aria-hidden="true"></i> {{ 'VERROU.TITLE' | translate }}</h2>
    <p class="verrou-sous-titre">{{ 'VERROU.SUBTITLE' | translate }}</p>

    <label class="verrou-etiquette" id="verrou-etiquette">{{ 'PIN.ENTER' | translate }}</label>
    <p-inputOtp
      [(ngModel)]="nip"
      [length]="longueur"
      [integerOnly]="true"
      [mask]="true"
      [disabled]="verification()"
      aria-labelledby="verrou-etiquette"
      (onChange)="soumettre($event.value)"
    />

    <p class="verrou-erreur" role="alert" [hidden]="!erreur()">{{ erreur() }}</p>

    <p-button
      [label]="'PIN.UNLOCK_BTN' | translate"
      icon="pi pi-lock-open"
      [loading]="verification()"
      [disabled]="nip.length !== longueur"
      (onClick)="soumettre()"
      styleClass="w-full mt-4"
    />
    <p-button
      [label]="'VERROU.LOGOUT' | translate"
      (onClick)="deconnecter()"
      styleClass="p-button-text p-button-sm w-full mt-2"
    />
  </div>
</div>
